// extracted by mini-css-extract-plugin
export default {"wrapper":"SectionPrice_wrapper__skgJX","price":"SectionPrice_price__a4MKa"};